export default {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#download",
      toString: function () {
        return this.url;
      }
    }